<script lang="ts">
  import type { BaseProps } from "#lib/internal/types"
  import { cn } from "#lib/utils"

  type Props = BaseProps & {
    label?: string
    chipRef?: HTMLDivElement | undefined
  }

  let {
    label = "",
    chipRef = $bindable(),
    class: className = "",
    ...restProps
  }: Props = $props()
</script>

<div
  class={cn(
    "select-chip border-general-neutral-alpha-02 bg-interaction-tag font-small-400 h-5 rounded-xs border px-1",
    className
  )}
  bind:this={chipRef}
  {...restProps}
>
  {label}
</div>
